<template>
  <keep-alive>
    <v-container
      fluid
      class="d-flex flex-column h-100 pa-0 min-height-inherit"
      :class="{ 'max-width-1500': profileType != 'Admin' }"
    >
      <div
        class="d-flex flex-row h-100 pa-0 min-height-inherit"
        :class="{ 'max-width-1500': profileType != 'Admin' }"
      >
        <agency-left-section
          class="hidden-sm-and-down"
          v-if="profileType == 'Agency'"
        />

        <volunteer-left-section
          class="hidden-sm-and-down"
          v-else-if="profileType == 'Volunteer'"
        />
        <admin-left-section
          class="hidden-sm-and-down"
          v-else-if="profileType == 'Admin'"
        />
        <router-view  v-if="profileType == 'Agency' || profileType == 'Volunteer'"/>
            <not-found v-else />
        <!-- <agency-right-section
          class="hidden-md-and-down"
          v-if="profileType == 'Agency'"
        />
        <volunteer-right-section
          class="hidden-md-and-down"
          v-else-if="profileType == 'Volunteer'"
        />
        <admin-right-section
          class="hidden-md-and-down"
          v-else-if="profileType == 'Admin'"
        /> -->
      </div>
      <v-snackbar v-model="snackbar">
        {{ errorMessage }}
      </v-snackbar>
    </v-container>
  </keep-alive>
</template>
<script>
import { mapGetters } from "vuex";
import VolunteerLeftSection from "../volunteer/VolunteerLeftSection.vue";
import AgencyLeftSection from "../agency/AgencyLeftSection.vue";
// import AgencyRightSection from "../agency/AgencyRightSection.vue";
// import VolunteerRightSection from "../volunteer/VolunteerRightSection.vue";
// import AdminRightSection from "../admin/AdminRightSection.vue";
import AdminLeftSection from "../admin/home/AdminHomeSideMenu.vue";
import NotFound from "../NotFound.vue";
export default {
  components: {
    AgencyLeftSection,
    VolunteerLeftSection,
    AdminLeftSection,
    NotFound
  },
  data() {
    return {
      loading: false,
      errorMessage: null,
      snackbar: false,
      donations: [],
      errorDonations: []
    };
  },
  methods: {
    showErrorMessage(message) {
      this.errorMessage = message;
      this.snackbar = true;
    }
  },
  computed: {
    ...mapGetters({
      profileType: "auth/getType"
    })
  }
};
</script>
<style scoped></style>
